import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import axios from "axios";
import { ClasificadorRS } from "./modalClasificadorRS";
//UI
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";

const headCells = [
  {
    id: "",
    label: "CODIGO",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "DESCRIPCION",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "COD. IMPUESTO",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "OPCIONES",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];
export function TablaClasificadorRS(props) {
  /* variables de estado */
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);

  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [clasificador, setClasificador] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  /* metodo para filtrar la tabla */

  const handleSearch2 = (e) => {
    let target = e.target;
    if ((target.name = "Search")) {
      target.value = target.value.toUpperCase();
      setFilterFn({
        fn: (items) => {
          if (target.value === "") {
            return items;
          } else {
            return items.filter((x) => {
              if (
                x.codigoordenanza
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                x.descripcion.toLowerCase().includes(target.value.toLowerCase())
              ) {
                return x;
              }
            });
          }
        },
      });
    }
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "claseaseo";
    let condi = "tipo = 1";
    let orden = "idclaseaseo";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden} `;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idclaseaseo) => {
    let campos = "*";
    let nomtab = "claseaseo";
    let nomid = "idclaseaseo";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idclaseaseo}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idclaseaseo > 0) {
            setClasificador(response.data);
            setActivate(false);
            setMostrar5(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const consultarClasificador = (ope, id) => (event) => {
    event.preventDefault();
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else if (ope === 4) {
      setOperacion(4);
      seleccionarRegistro(id);
    } else if (ope === 2) {
      setOperacion(2);
      seleccionarRegistro(id);
    } else if (ope === 3) {
      setOperacion(3);
      seleccionarRegistro(id);
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
    blanquearCampos();
  };

  const blanquearCampos = () => {
    setActivate(false);
    setOperacion(0);
    setClasificador();
  };
  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
            <h3 className="fw-bold m-0">Gestion de Clasificador de Aseo Municipal</h3>
            <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
            Salir <i className="fa fa-times ms-2"></i>
            </a>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
            <div className="col-4 m-0 p-0">
            <SearchInput
                placeholder="Buscar"
                onChange={handleSearch2}
                name="Search"
            />
            </div>
            <div className="col-auto m-0 p-0">
            <PrimaryButton icon = 'fa-plus m-0'
                onClick={consultarClasificador(1, "")}
            />
            </div>
        </div>
        <div className="col-12 m-0 p-0">
        <TblContainer>
            <TblHead />

            <tbody>
            {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idclaseaseo} style={{ padding: "0" }}>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10px",
                    }}
                    >
                    {item.codigoordenanza}
                    </td>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "220px",
                    }}
                    >
                    {item.descripcion}
                    </td>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "80px",
                    }}
                    >
                    {item.monto}
                    </td>

                    <td
                    className="py-1"
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "80px",
                    }}
                    >
                    <button
                        onClick={consultarClasificador(
                        4,
                        item.idclaseaseo
                        )}
                        className="btn btn-sm btn-info rounded-circle"
                    >
                        <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                        onClick={consultarClasificador(
                        2,
                        item.idclaseaseo
                        )}
                        className="btn btn-sm btn-warning rounded-circle"
                    >
                        <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                        onClick={consultarClasificador(
                        3,
                        item.idclaseaseo
                        )}
                        className="btn btn-sm btn-danger rounded-circle"
                    >
                        <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
        </TblContainer>
        <TblPagination />
        </div>
      <ClasificadorRS
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
        clasificador={clasificador}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}
